import { forwardRef } from 'react';
import { StyledMeta } from './styled';

const Meta = forwardRef((props, ref) => <StyledMeta ref={ref} {...props} />);

export default Meta;
